<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          {{ domainName }}
          <v-btn icon @click="$router.push('/businessfunction')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Business Type</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="domainName" filled readonly />
                <font color="red" class="v-virtual-table">{{ text }}</font>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Value Stream</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="valueStream" filled readonly />
              </v-col>
            </v-row>
            <v-row no-gutters v-for="(step, index) in steps" :key="index">
              <v-col sm="2"
                ><label v-if="index === 0" class="custom-form__label"
                  >Steps</label
                ></v-col
              >
              <v-col class="d-flex steps-col" sm="8">
                <v-text-field v-model="step.stepName" filled readonly />
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { storeActions } from '@/store/actions.constants';
import { mapActions, mapGetters } from 'vuex';
export default {
  data: () => ({
    valid: false,
    stepName: null,
    isDuplicate: false,
    text: '',
    valueStream: null,
    businessObj: {},
    steps: [],
    domainTotalList: [],
    domainData: [],
    domainName: '',
    domainId: null,
    vsmId: null,
    search: '',
    page: 1,
    itemsPerPage: 10,
    loading: false,
    sortDesc: [],
    options: {},
    nameRules: [
      (v) => !!v || 'Value Stream is Required',
      (v) =>
        /^[a-zA-Z][a-zA-Z0-9\s]{2,19}$/.test(v) ||
        'Special characters and Initial numbers are not allowed and string length must be between 3 to 20.',
    ],
    stepRules: [
      (v) => !!v || 'Step is Required',
      (v) =>
        /^[a-zA-Z][a-zA-Z0-9\s]{2,19}$/.test(v) ||
        'Special characters and Initial numbers are not allowed and string length must be between 3 to 20.',
    ],
  }),
  computed: {
    ...mapGetters({
      domains: 'businessFunction/getDomains',
      vsmList: 'businessFunction/getVsm',
    }),
    domainList() {
      return this.domains.data.map((domain) => ({
        id: domain.id,
        domainName: domain.name,
      }));
    },
  },
  async mounted() {
    let paramsId = this.$route.params.id;
    await this.getVsmById(paramsId);
    this.steps.push({ stepName: '' });
    let res = await this.getDomains({ page: 1, limit: 100 });
    this.domainTotalList = res.data;
  },
  methods: {
    ...mapActions({
      getVsm: 'businessFunction/getVsmById',
      getDomainById: 'domains/getDomainById',
      getDomains: 'businessFunction/getDomain',
    }),
    async getDomainsList() {
      this.loading = true;
      const { sortBy } = this.options;
      await this.getDomains({
        page: this.page,
        limit: 10,
        search: this.search || '',
        // sort: sortBy[0],
        // desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    getVsmById(paramsId) {
      this.loading = true;
      const domainObj = {
        id: paramsId,
      };
      this.getVsm(domainObj)
        .then((res) => {
          this.loading = false;
          this.domainName = res.data.domainName;
          this.valueStream = res.data.name;
          this.vsmId = res.data.vsmId;
          this.steps = res.data.steps;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          this.text = err.message;
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
